import { ProfileRouting } from "./profile.routing";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ProfileComponent } from "./profile/profile.component";
// import { NotFoundComponent } from '../../components/not-found/not-found.component';
import { GuestLayoutModule } from "../../layouts/auction-guest/guest-layout.module";
import { SharedModule } from "../shared/shared.module";
import { NgSelectModule } from "@ng-select/ng-select";
import { ProfileNavbarComponent } from "./profile-navbar/profile-navbar.component";
import { ChangePasswordComponent } from "./change-password/change-password.component";
import { BankDetailsComponent } from "./bank-details/bank-details.component";
import { MyAuctionsComponent } from "./my-auctions/my-auctions.component";
import { FavoritesComponent } from "./favorites/favorites.component";
import { NotificationsComponent } from "./notifications/notifications.component";
import { TransactionHistoryComponent } from "./transaction-history/transaction-history.component";
import { PersonalInformationComponent } from "./personal-information/personal-information.component";

@NgModule({
  declarations: [
    ProfileComponent,
    ProfileNavbarComponent,
    ChangePasswordComponent,
    BankDetailsComponent,
    MyAuctionsComponent,
    FavoritesComponent,
    NotificationsComponent,
    TransactionHistoryComponent,
    PersonalInformationComponent,
  ],
  entryComponents: [
    ProfileComponent,
    ProfileNavbarComponent,
    ChangePasswordComponent,
    BankDetailsComponent,
    MyAuctionsComponent,
    FavoritesComponent,
    NotificationsComponent,
    TransactionHistoryComponent,
    PersonalInformationComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GuestLayoutModule,
    ProfileRouting,
    SharedModule,
    NgSelectModule,
  ],
})
export class ProfileModule {}
